import React, { useReducer } from "react"
export const ModalContext = React.createContext({
  modal: null,
  setModal: (arg :any) => arg,
})
